import { Flow_0_0_2 } from '@flexus/core';

export const BUI_82: Flow_0_0_2 = {
	id: '82',
	name: 'job_created_and_allocated',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to accept new job'
		}
	},
	startNode: '',
	nodes: {}
};
